import { REFRESH_VIEW } from 'store/actions/listActions';
import {
    CRUD_UPDATE_SUCCESS
} from 'store/actions/dataActions';
import { STORAGE_MY_EMAIL_ADDRESS_KEY } from 'util/constants';

const initialState = 0;
export default (previousState = initialState, { type, requestPayload, meta }) => {

    switch (type) {
        case REFRESH_VIEW:
            return previousState + 1;

        case CRUD_UPDATE_SUCCESS:
            // 로그인한 계정의 관리자 정보를 변경한 경우 refresh
            if( meta.menu === 'DOMAIN.ADMIN' && requestPayload.params.mailUid === localStorage.getItem(STORAGE_MY_EMAIL_ADDRESS_KEY).split("@")[0] ) {
                return previousState + 1;
            } else {
                return previousState;
            }

        default:
            return previousState;
    }

}